import { Assert } from 'ku4es-kernel';
export const success = response => Assert.exists(response) && /^2\d{2}$/.test(response.status);
export const invalid = response => Assert.exists(response) && /^400$/.test(response.status);
export const unauthorized = response => Assert.exists(response) && /^401$/.test(response.status);
export const forbidden = response => Assert.exists(response) && /^403$/.test(response.status);
export const conflict = response => Assert.exists(response) && /^409$/.test(response.status);
export const unprocessable = response => Assert.exists(response) && /^422$/.test(response.status);
export const error = response => Assert.exists(response) && /^5\d{2}$/.test(response.status);
